const rewardsList = [
	{
		rewardName: "review",
		rewardDescription: "Write a Review",
		rewardIcon: "./images/rewards-icon-review.svg",
		rewardIconFilled: "./images/rewards-icon-filled-review.svg",
		rewardPoints: "200",
		rewardNumber: 1
	},
	{
		rewardName: "twitter",
		rewardDescription: "Share on Twitter",
		rewardIcon: "./images/rewards-icon-twitter.svg",
		rewardIconFilled: "./images/rewards-icon-filled-twitter.svg",
		rewardPoints: "125",
		rewardNumber: 2
	},
	{
		rewardName: "spend",
		rewardDescription: "Spend $100",
		rewardIcon: "./images/rewards-icon-spend.svg",
		rewardIconFilled: "./images/rewards-icon-filled-spend.svg",
		rewardPoints: "150",
		rewardNumber: 3
	},
	{
		rewardName: "upload",
		rewardDescription: "Upload a Photo",
		rewardIcon: "./images/rewards-icon-upload.svg",
		rewardIconFilled: "./images/rewards-icon-filled-upload.svg",
		rewardPoints: "200",
		rewardNumber: 4
	},
	{
		rewardName: "birthday",
		rewardDescription: "Birthday Gift",
		rewardIcon: "./images/rewards-icon-birthday.svg",
		rewardIconFilled: "./images/rewards-icon-filled-birthday.svg",
		rewardPoints: "100",
		rewardNumber: 5
	},
	{
		rewardName: "fblike",
		rewardDescription: "Like on Facebook",
		rewardIcon: "./images/rewards-icon-fblike.svg",
		rewardIconFilled: "./images/rewards-icon-filled-fblike.svg",
		rewardBg: "./images/industry-beauty-1.jpg",
		rewardPoints: "125",
		rewardNumber: 6
	},
	{
		rewardName: "shop",
		rewardDescription: "Make a Purchase",
		rewardIcon: "./images/rewards-icon-shop.svg",
		rewardIconFilled: "./images/rewards-icon-filled-shop.svg",
		rewardPoints: "100",
		rewardNumber: 7
	},
	{
		rewardName: "fbshare",
		rewardDescription: "Share on Facebook",
		rewardIcon: "./images/rewards-icon-fbshare.svg",
		rewardIconFilled: "./images/rewards-icon-filled-fbshare.svg",
		rewardPoints: "150",
		rewardNumber: 8
	},
	{
		rewardName: "account",
		rewardDescription: "Create an Account",
		rewardIcon: "./images/rewards-icon-account.svg",
		rewardIconFilled: "./images/rewards-icon-filled-account.svg",
		rewardPoints: "100",
		rewardNumber: 9
	},
	{
		rewardName: "newsletter",
		rewardDescription: "Sign Up for Newsletter",
		rewardIcon: "./images/rewards-icon-newsletter.svg",
		rewardIconFilled: "./images/rewards-icon-filled-newsletter.svg",
		rewardPoints: "100",
		rewardNumber: 10
	},
	{
		rewardName: "instagram",
		rewardDescription: "Follow on Instagram",
		rewardIcon: "./images/rewards-icon-instagram.svg",
		rewardIconFilled: "./images/rewards-icon-filled-instagram.svg",
		rewardPoints: "100",
		rewardNumber: 11
	},

	{
		rewardName: "bonus",
		rewardDescription: "Reach 3rd Purchase",
		rewardIcon: "./images/rewards-icon-bonus.svg",
		rewardIconFilled: "./images/rewards-icon-filled-bonus.svg",
		rewardPoints: "125",
		rewardNumber: 12
	}
];

export default rewardsList;
